import classNames from "classnames";
import "./RDCModalBody.scss";

interface RDCModalBodyProps extends React.HTMLAttributes<HTMLDivElement> {
	pTextCentered?: boolean;
    scrolled?: "scroll" | "scroll-y" | "scroll-x" | "";
};

export const RDCModalBody: React.FC<RDCModalBodyProps> = ({ children, scrolled = "", className, style, pTextCentered = false }) => {
	const modalClasses = classNames( "rdc_modal__body", className, scrolled, { "pcenter": pTextCentered } );
	return (
		<div className={modalClasses} style={style}>
			{children}
		</div>
	);
};
